export const MODULE_LAYOUT_VALUES = ['note', 'task'] as const;

export type ModuleLayout = (typeof MODULE_LAYOUT_VALUES)[number];
